import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import EmptyProductList from "theme/modules/ProductList/EmptyProductList";

const EmptyCategory = (props) =>
  props.hasFilters ? (
    <EmptyProductList>
      <FormattedMessage
        id="modules.Category.EmptyCategory.noProductsForFilters"
        defaultMessage={`No product available for your filters`}
      />
    </EmptyProductList>
  ) : (
    <EmptyProductList>
      <FormattedMessage
        id="modules.Category.EmptyCategory.empty"
        defaultMessage="Oops... This category is empty"
      />
    </EmptyProductList>
  );

EmptyCategory.propTypes = {
  hasFilters: PropTypes.bool,
};

export default EmptyCategory;
